module.exports = __webpack_public_path__ + "img/bg.bb5a3267.jpg";